import http from "../01_axios"
import {
  apiApproveJoinAssociationRequest,
  apiAssignRole,
  apiCancelLeaveRequest,
  apiCreatIndividual,
  apiCreateOrganization,
  apiDeleteMember,
  apiDeleteUserAssociation,
  apiGetAllMemberForCategory,
  apiGetLisTLogUserAssociation,
  apiGetListJoinRequest,
  apiGetListMember,
  apiGetMemberDetail,
  apiGetMemberDetailToUpgrade,
  apiJoinAssociationRequest,
  apiLeaveRequest,
  apiRegisterIndividual,
  apiRegisterOrganization,
  apiRejectJoinAssociationRequest,
  apiUpdateMemberDetailToUpgrade,
  apiUploadMembershipUpgradeForm,
} from "./urls"

const AssignRole = body => http.post(apiAssignRole, body)

const RegisterOrganization = body => http.post(apiRegisterOrganization, body)
const RegisterIndividual = body => http.post(apiRegisterIndividual, body)

const getListJoinRequest = params => http.get(apiGetListJoinRequest, { params })

const approveJoinRequest = body =>
  http.post(apiApproveJoinAssociationRequest, body)

const rejectJoinRequest = body =>
  http.post(apiRejectJoinAssociationRequest, body)

const getMemberDetail = params => http.get(apiGetMemberDetail, { params })
const CreateIndividual = body => http.post(apiCreatIndividual, body)
const CreateOrganization = body => http.post(apiCreateOrganization, body)
const getListMemberByGet = params => http.get(apiGetListMember, { params })
const deleteMember = body => http.post(apiDeleteMember, body)
const deleteUserAssociation = (associationId, userIds) =>
  http.post(apiDeleteUserAssociation, userIds, {
    params: { AssociationId: associationId },
  })

// const GetMemberDetail = params =>
//   http.get(apiGetMemberDetail + `?${QueryString.stringify(params)}`)
const getListMember = body => http.post(apiGetListMember, body)

const GetLisTLogUserAssociation = params =>
  http.get(apiGetLisTLogUserAssociation, { params })

const leaveRequest = body => http.post(apiLeaveRequest, body)
const cancelLeaveRequest = body => http.post(apiCancelLeaveRequest, body)
const getAllMemberForCategory = params =>
  http.get(apiGetAllMemberForCategory, { params })
const getMemberDetailToUpgrade = params =>
  http.get(apiGetMemberDetailToUpgrade, { params })
const updateMemberDetailToUpgrade = body =>
  http.put(apiUpdateMemberDetailToUpgrade, body)
const uploadMembershipUpgradeForm = body =>
  http.post(apiUploadMembershipUpgradeForm, body)
const joinAssociationRequest = body =>
  http.post(apiJoinAssociationRequest, body)

const MemberService = {
  uploadMembershipUpgradeForm,
  getMemberDetailToUpgrade,
  updateMemberDetailToUpgrade,
  getListMember,
  getListJoinRequest,
  approveJoinRequest,
  rejectJoinRequest,
  getMemberDetail,
  CreateOrganization,
  CreateIndividual,
  getListMemberByGet,
  deleteMember,
  RegisterOrganization,
  RegisterIndividual,
  GetLisTLogUserAssociation,
  leaveRequest,
  cancelLeaveRequest,
  getAllMemberForCategory,
  joinAssociationRequest,
  AssignRole,
  deleteUserAssociation,
}

export default MemberService
